


const widths = [ "w-1/12", "w-1/12", "w-1/12", "w-1/12", "w-2/12", "w-1/12", "w-1/12", "w-1/12", "w-2/12", "w-1/12" ]

const columns = [
  { id: 1, label: "Trx Date" },
  { id: 2, label: "Amount" },
  { id: 3, label: "BIN" },
  { id: 4, label: "Last Four" },
  { id: 5, label: "Cust. Name" },
  { id: 6, label: "Merch Ref" },
  { id: 7, label: "Type" },
  { id: 8, label: "TransId" },
  { id: 9, label: "AuthCode" },
]

const data = [
  { 
    id: 1, 
    trxDate: "Dec 1, 2024", 
    amount: "320.75", 
    bin: "514887", 
    lastFour: "0859", 
    custName: "KHAYMAN ENGLE", 
    merchRef: "3389518", 
    type: "sale", 
    transId: "10176861244", 
    authCode: "03317Z" 
  },
]

export const trx_history_data = {
  widths,
  columns,
  data
}